import { render } from "./CountryFlag.vue?vue&type=template&id=5c6444de&scoped=true&ts=true&lang=pug"
import script from "./CountryFlag.vue?vue&type=script&lang=ts"
export * from "./CountryFlag.vue?vue&type=script&lang=ts"

import "./CountryFlag.vue?vue&type=style&index=0&id=5c6444de&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6444de"]])

export default __exports__